import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  detailCard: {
    padding: [24, 32],
    margin: [0, 0, 30],
    width: '100%',
    maxWidth: 580,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',

    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: 'rgba(255, 255, 255, 0.1)',

    backgroundColor: '#ffffff1a',

    [theme.media.tablet]: {
      width: '100%',
      padding: [28, 100],
      margin: [10, 0, 30]
    }
  },

  planHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  planName: {
    fontFamily: 'GTWalsheim',
    fontSize: '18px',
    fontWeight: 600,
    color: '#ffffff'
  },

  planPrice: {
    fontFamily: 'GTWalsheim',
    fontSize: '16px',
    fontWeight: 600,
    color: '#ffffff'
  },

  detailList: {
    listStyle: 'none',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: 0
  },

  detailItem: {
    lineHeight: 1.5,
    display: 'flex',
    justifyContent: 'start'
  },

  detailLabel: {
    fontFamily: 'GTWalsheim',
    fontSize: '16px',
    fontWeight: 500,
    color: '#ffffff'
  },

  detailValue: {
    fontFamily: 'GTWalsheim',
    fontSize: '16px',
    fontWeight: 500,
    color: theme.neonPrimary
  },

  badge: {
    alignSelf: 'flex-start',
    fontFamily: 'GothamRounded',
    fontWeight: 500,
    fontSize: 16,
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: [6, 10, 3, 10],
    backgroundColor: theme.neonPrimary,
    borderRadius: [8, 0, 8, 0],
    color: '#000'
  }
}))
